module.exports = __webpack_public_path__ + "media/Edward.c2195255.mp4";